import { initGlobalState } from 'qiankun'
import { MainService } from './mainService'

const globalState = {
  MainService,
}
// 初始化 state
export const actions = initGlobalState(globalState)

// actions.onGlobalStateChange((state, prev) => {
//   // state: 变更后的状态; prev 变更前的状态
//   console.log(state, prev)
// })
// actions.setGlobalState({})
// actions.offGlobalStateChange()
